import type { SecurityDashboardLayoutV1 } from '@/lib/security-dashboard-layout'
import type { SecurityDashboardPdfPagination } from '@/lib/security-dashboard-pdf-pagination'

/** sessionStorage key written by Playwright before the print page loads. */
export const SECURITY_DASHBOARD_PDF_SNAPSHOT_STORAGE_KEY = 'securityDashboardPdfSnapshot'

/** Snapshot passed into the headless browser so the print route does not rely on server in-memory Maps. */
export type SecurityDashboardPdfInjectedSnapshot = {
  pdfSid: string
  layout: SecurityDashboardLayoutV1
  theme: 'light' | 'dark'
  tenantId: string
  currentTenantName?: string
  selectedTenantIds?: string[]
  pagination?: SecurityDashboardPdfPagination
}

/**
 * Headless Playwright uses an injected snapshot; JWT may be expired while the backend session is still valid.
 * Auth flows that hard-redirect to `/` or clear storage must skip this context or PDF generation will never reach `data-pdf-ready`.
 */
export function isSecurityDashboardPdfPrintBrowserContext(): boolean {
  if (typeof window === 'undefined') return false
  if (window.location.pathname.includes('/dashboard/print')) return true
  try {
    return Boolean((window as unknown as { __securityDashboardPdfSnapshot?: unknown }).__securityDashboardPdfSnapshot)
  } catch {
    return false
  }
}
